export default __webpack_public_path__ + "static/media/AmoryRendering.8713b85a.png";